export const animate = (elem, prop, targetValue, options) => {
  const start = performance.now();
  const initValue = elem[prop];
  const deltaValue = targetValue - initValue;
  const { duration, timing = 'linear' } = options;

  function step(time) {
    let timePassed = time - start;
    if (timePassed > duration) {
      timePassed = duration;
    }
    const dT = timingFanctions[timing](timePassed / duration);
    elem[prop] = initValue + dT * deltaValue;
    if (timePassed < duration) {
      window.requestAnimationFrame(step);
    }
  }
  window.requestAnimationFrame(step);
};

const timingFanctions = {
  linear: (timeFraction) => timeFraction,
  circ: (timeFraction) => 1 - Math.sin(Math.acos(timeFraction)),
  quad: (timeFraction) => timeFraction ** 2,
};
